import type { CalendarEventType } from '@axiom/validation';
import { DateUtil } from '@axiom/ui';
import moment from 'moment-timezone';

export const InterviewAvailabilityConst = {
  minimumHoursRequired: 8,
};

export const InterviewAvailabilityUtil = {
  calculateAvailabilityWithinNextTwoWeeks: (events: CalendarEventType[]) => {
    const twoWeeksFromNow = moment().utc().add(2, 'weeks').toDate();

    return events.reduce((acc, curr) => {
      if (
        !curr.busy &&
        DateUtil.isDateBeforeDate(curr.endTime, twoWeeksFromNow)
      ) {
        acc += DateUtil.calculateHoursBetween(curr.startTime, curr.endTime);
      }
      return acc;
    }, 0);
  },
};
